module.exports = __webpack_public_path__ + "media/images/logos/twitch-light-2d013dbb073c47f82ac74ec5e11f9b50.svg";